import { TaxForm, UploadedFile, UploadedTaxDocument, UploadedTaxForm } from "./tax_document";
import { SaveTaxReturnResponse, TaxReturn } from "./tax_return";

export interface IRS1040Form extends TaxForm {
    wages_salary_tips: number | string;
    other_income: number | string;
}

export interface UploadedIRS1040Form extends UploadedTaxForm<IRS1040Form> {}

export const empty1040Form: Uploaded1040Document = {
    id: -1,
    file_name: "",
    file_storage_url: "",
    tax_document: {
        form_data: {
            wages_salary_tips: "",
            other_income: ""
        }
    }
};

export interface Uploaded1040Document extends UploadedTaxDocument<UploadedIRS1040Form> {}

export interface Save1040Response extends Uploaded1040Document, SaveTaxReturnResponse {};
